import "./EquityPortfolioImpactComponent.scss";
import template from "./EquityPortfolioImpactComponent.html";

export const EquityPortfolioImpact = "tfEquityPortfolioImpact";

export function equityPortfolioImpact() {
    return {
        template,
        bindings: {
            cashAfterTrade: "<",
            currentBalance: "<",
            feesAndBrokerage: "<",
            tradeFees: "<",
            totalCost: "<"
        },
        controllerAs: "ctrl",
        controller: () => {} // Dummy controller as there is no logic in there
    };
}
